export default "__VITE_ASSET__BJ4iE9ib__"